import { Container } from "react-bootstrap";
import Layout from "../../shared/components/Layout";
import Header from "../../shared/components/Header";
import ProfileDetails from "../component/ProfileDetails";

const ProfileIndex = () => {
  return (
    <Layout>
      <Header title="Manage Profile" />
      <Container
        fluid
        className="px-4 py-2 "
        style={{
          height: "calc(100vh - 10px)",
          overflowy: "scroll",
          overflowX: "hidden",
        }}
      >
        <ProfileDetails  />
      </Container>
    </Layout>
  );
};

export default ProfileIndex;
